import React, { useEffect, useState } from "react";
import "../../src/assets/AdminCss/CricketScoreboard.css"; 

const FootballScoreboard = () => {
  const [eventId, setEventid] = useState(0);

  // ✅ New state for toggle
  const [showScoreboard, setShowScoreboard] = useState(false);

  
  useEffect(() => {
    setEventid(sessionStorage.getItem("eventid"));
  },[]);

  return (
    <div className="scoreboard-wrapper">
      {/* ✅ Toggle Button */}
      <div
        onClick={() => setShowScoreboard((prev) => !prev)}
        className="p-2 fs-6 btn-danger w-100"
      >
        {showScoreboard ? "Hide Scoreboard" : "Show Scoreboard"}
      </div>

      {/* ✅ Conditionally render scoreboard */}
      {showScoreboard && (
        <iframe
                              title="Live TV"
                              className="border w-100 "
                              // style={{ height: "20vh" }}
                              // src={`https://score.tresting.com/socket-iframe-1/crickexpo/${eventId}`}
                              src={`https://e765432.diamondcricketid.com/sr.php?eventid=${eventId}&sportid=1`}
                              allowFullScreen
                              referrerPolicy="strict-origin-when-cross-origin"
                              sandbox="allow-same-origin allow-scripts"
                            ></iframe>
      )}
    </div>
  );
};

export default FootballScoreboard;
